import React from 'react'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import DoneIcon from '@material-ui/icons/Done'
import ModeEditIcon from '@material-ui/icons/ModeEdit'
import SwapVertIcon from '@material-ui/icons/SwapVert'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import InputLabel from '@material-ui/core/InputLabel';
import Tooltip from '@material-ui/core/Tooltip';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input'
import ListItemText from '@material-ui/core/ListItemText'
import Checkbox from '@material-ui/core/Checkbox'
import Select from '@material-ui/core/Select';
import Slide from '@material-ui/core/Slide'
import DetailForm from './detailForm'
import NoData from '../../../../../uis/noData'
import Pagination from '../../../../../uis/pagination'
import * as copyActions from '../../order_copy/reducers/list'
import {HIDE_MODAL,CHANGE_SELECT_ROLE,SHOW_MODAL,CHANGE_PAGE,CHANGE_SEARCH_VALUE,SHOW_USER_MODAL,getList,getRoleList,add,update,changeRole} from '../reducers/list'


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    changeRolebutton: {
        color: '#7f43a3'
    },
    labelStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
    },
    labelText: {
        width: 100,
        textAlign: 'right',
        marginRight: 20
    },
    mulSelect: {
        width: 300
    },
    radioSelect: {
        display: 'flex',
        justifyContent: 'center',
        width: 300,
        flexDirection: 'row'
    },
    inputStyle: {
        width: 300
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
});

function Transition(props) {
    return <Slide direction="up" {...props} />
}

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 200
        }
    }
}

class User extends React.Component {
    constructor(props) {
        super(props)
        this.onPageClick = this.onPageClick.bind(this)
        this.handleNewUser = this.handleNewUser.bind(this)
    }
    componentDidMount() {
        const {dispatch} = this.props
        dispatch(getList());
        dispatch(getRoleList());
        dispatch(copyActions.getTechs())
    }
    onPageClick(index) {
        const {dispatch,page} = this.props
        dispatch({type: CHANGE_PAGE,page: {...page,index}})
        dispatch(getList())
    }
    handleSearch = () => {
        const {dispatch,page} = this.props
        dispatch({
            type: CHANGE_PAGE,
            page: {...page, index: 0}
        });
        dispatch(getList())
    }
    handleNewUser(formData) {
        const {dispatch,userInfo:{row},roleList} = this.props
        formData.roles = roleList.reduce((total, sub) => {
            formData.roles.includes(sub.name) && total.push(sub.id)
            return total
            }, [])
        if (!!row) {
            dispatch(update(row.id,formData))
        } else {
            dispatch(add(formData))
        } 
    }
    getDetail(row) {
        const {dispatch} = this.props
        row.roles = row.accountRoles.map(item => {return item.roleName})
        row.isActive = row.isActive.toString()
        dispatch({type: SHOW_USER_MODAL,key: 'add',row: row})
    }
    render() {
        const { classes,dispatch,page,total,list,userInfo,showModal,search,roleList,permissionMap, techs} = this.props
        return (
            <div>     
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['用户管理_新增'] && <Button variant="outlined" component="span" color="secondary" onClick={() => dispatch({type: SHOW_USER_MODAL,key: 'add'})}>新增用户</Button>}
                    </Grid>
                    <Grid item>
                        <TextField value={search.value} placeholder="搜索名字或手机号" onChange={(e) => dispatch({type: CHANGE_SEARCH_VALUE, value: e.target.value})} />
                        <IconButton onClick={() => this.handleSearch()}><SearchIcon /></IconButton>
                    </Grid>
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 &&<Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>用户名</TableCell>
                                <TableCell>角色</TableCell>
                                <TableCell>手机号</TableCell>
                                <TableCell>工作状态</TableCell>
                                {permissionMap['用户管理_修改'] && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((row,index) => {
                                let workStatus = '正常';
                                if (row.workStatus === '请假' && new Date(row.workLeaveStartTime) < new Date() && new Date(row.workLeaveEndTime) > new Date()) {
                                    workStatus = `请假(${new Date(row.workLeaveStartTime).toLocaleString()}~${new Date(row.workLeaveEndTime).toLocaleString()})`
                                }
                                return (
                                    <TableRow key={index} style={{opacity: row.isActive ? '1' : '0.5',height: 80}}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{(row.accountRoles || []).map((item) => {return item.roleName}).join(',')}</TableCell>
                                        <TableCell>{row.phone}</TableCell>
                                        <TableCell>{workStatus}</TableCell>
                                        {permissionMap['用户管理_修改'] && <TableCell>
                                            <Tooltip id="edit" title="调整角色">
                                                <IconButton className={classes.changeRolebutton} onClick={() => dispatch({type: SHOW_MODAL,key: 'changeRole',curRoles: row.accountRoles.map(item => {return item.roleName}),id: row.id})} ><SwapVertIcon /></IconButton>
                                            </Tooltip>
                                            <Tooltip id="edit" title="编辑">
                                                <IconButton color="primary" onClick={() => this.getDetail(row)}><ModeEditIcon /></IconButton>
                                            </Tooltip>
                                            <Tooltip id="clear" title={row.isActive ? "关闭" : "激活"}>
                                                <IconButton color="secondary" onClick={() => dispatch({type: SHOW_USER_MODAL,key: 'status',row,isActive: !row.isActive})}>{row.isActive ? <ClearIcon /> : <DoneIcon />}</IconButton>
                                            </Tooltip>
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                {...page}
                                total={total}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                <Dialog
                    open={userInfo.add}
                    onClose={() => dispatch({type: HIDE_MODAL})}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    fullWidth
                >
                    <DialogContent>
                        <DetailForm 
                            onSubmit={this.handleNewUser} 
                            roleList={roleList} 
                            onCancel={() => dispatch({type: HIDE_MODAL})}
                            techs={techs}
                        />
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={userInfo.status}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => dispatch({type: HIDE_MODAL})}
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>确定{userInfo.isActive ? '激活' : '关闭'}吗？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" component="span" onClick={() => dispatch({type: HIDE_MODAL})}>
                            取消
                        </Button>
                        <Button variant="outlined" component="span" color="secondary" onClick={() => dispatch(update(userInfo.row.id,{isActive: userInfo.isActive}))}>
                            确定
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={showModal.changeRole}
                    TransitionComponent={Transition}
                    onClose={() => dispatch({type: HIDE_MODAL})}
                    fullWidth
                >
                    <DialogContent>
                        <label className={classes.labelStyle}>
                            <span className={classes.labelText}>角色：</span>
                            <FormControl>
                                <InputLabel htmlFor="角色选择"></InputLabel>
                                <Select
                                    multiple
                                    value={showModal.curRoles.map(item => {return item})}
                                    input={<Input id="select-multiple-checkbox" />}
                                    renderValue={selected => selected.join(',')}
                                    MenuProps={MenuProps}
                                    onChange={(e) => dispatch({type: CHANGE_SELECT_ROLE, value: e.target.value})}
                                    className={classes.mulSelect}
                                >
                                    {roleList.map((item) => (
                                        <MenuItem key={item.id} value={item.name}>
                                            <Checkbox checked={showModal.curRoles.map(item => {return item}).indexOf(item.name) > -1} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </label>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" component="span" onClick={() => dispatch({type: HIDE_MODAL})}>
                            取消
                        </Button>
                        <Button 
                            variant="outlined" 
                            component="span" 
                            color="secondary" 
                            type="submit" 
                            onClick={() => dispatch(changeRole(roleList.reduce((total, sub) => {
                            showModal.curRoles.includes(sub.name) && total.push(sub.id)
                            return total}, [])))}
                        >
                            确定
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.userManagement,
        techs: state.orderCopy.techs,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(User))


// WEBPACK FOOTER //
// ./src/pages/home/routes/user/components/list.js